import React, { useEffect } from 'react'
import Accordion from 'src/components/Global/Accordion/Accordion'
import { Wrapper } from './style'
import { SettingTitleText } from 'src/components/Global/Text/TitleText'
import { useTypedSelector } from 'src/redux/root-reducer'
import { getAllFaqsAction } from 'src/redux/actions/faqActions'
import { useDispatch } from 'react-redux'
import { SkeletonFaq } from 'src/components/Global/Skeletons/FaqSkeleton'
import { CloseModal } from 'src/assets'
import { useNavigate } from 'react-router'
const Faq = () => {
  const allFaqs = useTypedSelector((state) => state.faqs.faq)
  const faqLoading = useTypedSelector((state) => state.faqs.faqLoading)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    dispatch(getAllFaqsAction())
  }, [dispatch])
  return (
    <Wrapper>
      <div className="flexed">
        <div>
          <SettingTitleText className="title">FAQ</SettingTitleText>
          <h2>How can we help?</h2>{' '}
        </div>
        <div onClick={() => navigate(-1)}>
          <img src={CloseModal} alt="Close" />
        </div>
      </div>
      <div className="loading">
        {faqLoading &&
          [1, 2, 3, 4, 5].map((n) => <SkeletonFaq key={n} theme="light" />)}
      </div>

      {!faqLoading &&
        allFaqs?.map((faq: any) => (
          <Accordion question={faq.question} answer={faq.answer} />
        ))}
    </Wrapper>
  )
}
export { Faq }
